import React from 'react';
import PropTypes from 'prop-types';

/**
 * Composant Image optimisé avec support AVIF > WebP > PNG/JPG
 * Utilise l'élément <picture> pour servir le meilleur format supporté
 */
const OptimizedImage = ({
  avifSrc,
  webpSrc,
  fallbackSrc,
  alt,
  className = '',
  loading = 'lazy',
  fetchpriority,
  width,
  height,
  ...props
}) => {
  return (
    <picture>
      {/* Source AVIF (meilleur compression, navigateurs modernes 2023+) */}
      {avifSrc && <source srcSet={avifSrc} type="image/avif" />}

      {/* Source WebP (bon compromis, navigateurs 2020+) */}
      {webpSrc && <source srcSet={webpSrc} type="image/webp" />}

      {/* Fallback PNG/JPG pour navigateurs anciens */}
      <img
        src={fallbackSrc}
        alt={alt}
        className={className}
        loading={loading}
        fetchpriority={fetchpriority}
        width={width}
        height={height}
        {...props}
      />
    </picture>
  );
};

OptimizedImage.propTypes = {
  avifSrc: PropTypes.string,
  webpSrc: PropTypes.string,
  fallbackSrc: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  className: PropTypes.string,
  loading: PropTypes.oneOf(['lazy', 'eager']),
  fetchpriority: PropTypes.oneOf(['high', 'low', 'auto']),
  width: PropTypes.number,
  height: PropTypes.number,
};

export default OptimizedImage;
